import React, { useState, useEffect} from "react";
import Profile from "./profile/Profile";
import CircularProgress from '@mui/material/CircularProgress';
import sharedPowerResume from "../../apis/sharePoweResume/getSharedPowerResume";
import { useParams } from "react-router-dom";
import Header from "../../components/headerAdmin/Header";

const SharedAdminApplication = (props) => {
  let id = useParams();

  const [profileId, setprofileId] = useState("");
  const [isDataLoaded, setisDataLoaded] = useState(false);
  const [viewTestAccess, setViewTestAccess] = useState([]);

  const getSharedPoweResume = async (payload) => {
    try {
      const sharedPoweResumeResponse = await sharedPowerResume(payload);
      setisDataLoaded(true);
      setprofileId(sharedPoweResumeResponse.data.data[0]?.ProfileId);
      setViewTestAccess(sharedPoweResumeResponse.data.data[0]?.testAccess);
    } catch (error) {
      console.log(error);
      setisDataLoaded(true);
    }
  };

  useEffect(() => {
    if (id?.id) {
      getSharedPoweResume({ Id: id.id });
    }
  }, [id])
  
  return (
    <>
      <div>
        {profileId !== "" ? (
          <Profile candidateId={profileId} testAccess={viewTestAccess} isShare={true}  recruitmentpartnerId=""/>
        ) : (
          <>
            <Header />
            <div className="section-wrapper">
              <div className="profile-wrapper flex-to-footer">
                <div className="container w1004 mt_20">
                  <div className="container register-test-container">
                    <div className="card cardheight cardheight_endtest success-card mt_10 text-center">
                      <div className="end-test-container">
                        <div className="start_test_text_top">
                          {isDataLoaded ? (
                            <p className="fs-semi-bold fs-16 f-color">
                              The PoweResume link is invalid or expired
                            </p>
                          ) : (
                            <div className="row padding_80 text-center">
                              <CircularProgress />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SharedAdminApplication;
